// src/components/AvailabilityCalendar.jsx
import React, { useState, useEffect } from "react";
import { db } from "../firebase"; // Importujemy naszą bazę danych
import { collection, getDocs } from "firebase/firestore";
import "./AvailabilityCalendar.css";

const AvailabilityCalendar = () => {
  const [busySlots, setBusySlots] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBusySlots = async () => {
      setLoading(true);
      const querySnapshot = await getDocs(collection(db, "kalendarz"));
      const slots = {};
      querySnapshot.forEach((doc) => {
        // doc.id to np. '2025-07-10', a doc.data() to { hours: ['15:00', '16:00'] }
        slots[doc.id] = doc.data().hours;
      });
      setBusySlots(slots);
      setLoading(false);
    };

    fetchBusySlots();
  }, []);

  const hours = Array.from({ length: 14 }, (_, i) => `${8 + i}:00`); // 8:00 - 21:00
  const days = [];
  const today = new Date();

  for (let i = 0; i < 14; i++) {
    const date = new Date(today);
    date.setDate(today.getDate() + i);
    days.push(date);
  }

  const formatDate = (date) => date.toISOString().split("T")[0];

  if (loading) {
    return <p>Ładowanie kalendarza...</p>;
  }

  return (
    <div className="calendar-container">
      <div className="calendar-grid">
        <div className="header-cell"></div>
        {days.map((day) => (
          <div key={day} className="header-cell day-header">
            <div className="day-name">
              {day.toLocaleDateString("pl-PL", { weekday: "short" })}
            </div>
            <div className="day-number">
              {day.toLocaleDateString("pl-PL", { day: "numeric" })}
            </div>
          </div>
        ))}
        {hours.map((hour) => (
          <React.Fragment key={hour}>
            <div className="header-cell hour-header">{hour}</div>
            {days.map((day) => {
              const dateKey = formatDate(day);
              const isBusy =
                busySlots[dateKey] && busySlots[dateKey].includes(hour);
              return (
                <div
                  key={`${dateKey}-${hour}`}
                  className={`slot ${isBusy ? "busy" : "free"}`}
                  title={isBusy ? "Termin zajęty" : "Termin wolny"}
                ></div>
              );
            })}
          </React.Fragment>
        ))}
      </div>
      <div className="legend">
        <div className="legend-item">
          <div className="legend-box free"></div>
          <span>Termin wolny</span>
        </div>
        <div className="legend-item">
          <div className="legend-box busy"></div>
          <span>Termin zajęty</span>
        </div>
      </div>
    </div>
  );
};

export default AvailabilityCalendar;